export default __webpack_public_path__ + "static/media/plus.46105135.svg";